module.exports = __webpack_public_path__ + "img/gifts.3fd6a016.svg";